export const MAP_CALIBRATION_STORAGE_KEY = 'map-calibrations';
